import React from 'react';
import s from './s.module.less';
import LineBar from '../LineBar';
import { useNavigate } from 'react-router-dom';

const Index: React.FC = () => {
    const navigate = useNavigate();
    return (
        <div className={s.wrap}>
            <LineBar
                lineBarId="kiwi-2-1"
                icon="icon-2"
                title="Improve your services and pricing design"
                description="Conduct a comprehensive pricing check and adjust accordingly."
                details={`<ul>
                            <li>Price smartly: research diverse sources to provide affordable care (recommend to look into Psychology Today and Zocdoc, or email <a target="_blank" href="mailto:support@kiwihealth.com">support@kiwihealth.com</a> for advice)</li>
                        </ul>`}
                cta="Review my services"
                onCta={() => {
                    navigate(
                        '/create-uni-profile?type=uniprofile&from=home&step=6',
                    );
                }}
            />
            <LineBar
                lineBarId="kiwi-2-2"
                icon="icon-6"
                title="Actively collect patient feedback"
                description="Leverage Reputation Management tools."
                details={`<ul>
                        <li>Collect patient reviews from multiple channels</li>
                        <li>Respond to reviews to enhance patient satisfaction</li>
                    </ul>`}
                cta="Manage reviews"
                onCta={() => {
                    navigate('/dashboard/reputation-management');
                }}
            />
            <LineBar
                lineBarId="kiwi-2-3"
                icon="icon-5"
                title="Promote your services to build a patient base"
                description="Share your Practice Front to patients and social networks."
                details={`<ul>
                        <li>Insert your online scheduling link in Practice Front</li>
                        <li>Share Practice Front with your existing patients to promote your full service menu</li>
                        </ul>`}
                cta="Open Practice Front"
                onCta={() => {
                    navigate('/dashboard/marketing?mainTab=external&subTab=practice-front');
                }}
            />
        </div>
    );
};

export default Index;
